module.exports = __webpack_public_path__ + "img/bingo_ball-61.ee4d9cbe.png";